import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { DND_ITEM_TYPE_QUESTION, getColor, getSize } from '@lib/common';
import { useCallback, useRef } from 'react';
import { useDrop } from 'react-dnd';
import styled from 'styled-components';
import { useSidebarLiveDrag } from '../sidebar-live-drag.context';
import { jsx as _jsx } from "react/jsx-runtime";
var DropZone = styled.div.withConfig({
  displayName: "section-empty-drop-zonecomponent__DropZone",
  componentId: "sc-vub9hv-0"
})(["margin-left:", ";margin-top:", ";padding:", " ", ";border-radius:", ";border:1px dashed ", ";background-color:", ";color:", ";font-size:", ";text-align:center;transition:border-color 0.15s ease,background-color 0.15s ease,color 0.15s ease;"], getSize('padding24'), getSize('padding4'), getSize('padding12'), getSize('padding8'), getSize('radiusSm'), function (_ref) {
  var $isOver = _ref.$isOver,
      $canDrop = _ref.$canDrop;
  return $isOver && $canDrop ? getColor('fillIntActive') : '#cbd5e1';
}, function (_ref2) {
  var $isOver = _ref2.$isOver,
      $canDrop = _ref2.$canDrop;
  return $isOver && $canDrop ? '#eff6ff' : '#f8fafc';
}, function (_ref3) {
  var $isOver = _ref3.$isOver,
      $canDrop = _ref3.$canDrop;
  return $isOver && $canDrop ? getColor('fillIntActive') : '#94a3b8';
}, getSize('typo13'));
/**
 * Drop target for empty sections so questions can be moved in via DnD.
 */

export var SectionEmptyDropZone = function SectionEmptyDropZone(_ref4) {
  var sectionId = _ref4.sectionId,
      disabled = _ref4.disabled,
      _onDropQuestion = _ref4.onDropQuestion;

  var _useSidebarLiveDrag = useSidebarLiveDrag(),
      previewInSection = _useSidebarLiveDrag.previewInSection,
      commitCrossSectionMove = _useSidebarLiveDrag.commitCrossSectionMove;

  var sectionIdRef = useRef(sectionId);
  var previewInSectionRef = useRef(previewInSection);
  var commitRef = useRef(commitCrossSectionMove);
  sectionIdRef.current = sectionId;
  previewInSectionRef.current = previewInSection;
  commitRef.current = commitCrossSectionMove;
  var handleDrop = useCallback(function (item) {
    var targetSectionId = sectionIdRef.current;
    var sourceSectionId = item.originalSectionId;

    if (!sourceSectionId || sourceSectionId === targetSectionId) {
      return {
        dropped: false
      };
    }

    commitRef.current({
      questionId: item.id,
      targetSectionId: targetSectionId,
      targetIndex: 0,
      sourceSectionId: sourceSectionId
    });
    item.sectionId = targetSectionId;
    item.index = 0;
    return {
      dropped: true,
      crossSection: true,
      targetSectionId: targetSectionId,
      targetIndex: 0
    };
  }, []);

  var _useDrop = useDrop(function () {
    return {
      accept: DND_ITEM_TYPE_QUESTION,
      canDrop: function canDrop(item) {
        return !disabled && Boolean(item.originalSectionId) && item.originalSectionId !== sectionIdRef.current;
      },
      hover: function hover(item) {
        if (disabled) return;
        var targetSectionId = sectionIdRef.current;
        previewInSectionRef.current(targetSectionId, 0);
        item.sectionId = targetSectionId;
        item.index = 0;
      },
      drop: function drop(item, monitor) {
        if (monitor.didDrop()) return;
        return handleDrop(item);
      },
      collect: function collect(monitor) {
        return {
          isOver: monitor.isOver({
            shallow: true
          }),
          canDrop: monitor.canDrop()
        };
      }
    };
  }, [disabled, handleDrop]),
      _useDrop2 = _slicedToArray(_useDrop, 2),
      _useDrop2$ = _useDrop2[0],
      isOver = _useDrop2$.isOver,
      canDrop = _useDrop2$.canDrop,
      drop = _useDrop2[1];

  if (disabled) {
    return null;
  }

  return /*#__PURE__*/_jsx(DropZone, {
    ref: drop,
    $isOver: isOver,
    $canDrop: canDrop,
    children: isOver && canDrop ? 'Drop here' : 'Drop a question here'
  });
};